import { render } from "./cancelButton.vue?vue&type=template&id=a5585f28&scoped=true"
import script from "./cancelButton.vue?vue&type=script&lang=js"
export * from "./cancelButton.vue?vue&type=script&lang=js"

import "./cancelButton.vue?vue&type=style&index=0&id=a5585f28&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5585f28"]])

export default __exports__